import { Component, Inject, Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

export interface DialogOptions {
  message: string;
  width?: string;
  height?: string;
  confirmButtonLabel?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private matDialog: MatDialog) {}

  confirm(options: DialogOptions): Promise<boolean> {
    const dialogRef = this.matDialog.open(DialogConfirmationComponent, {
      width: options.width,
      height: options.height,
      data: {
        message: options.message,
        confirmButtonLabel: options.confirmButtonLabel,
      },
    });

    return lastValueFrom(dialogRef.afterClosed());
  }
}

@Component({
  selector: 'forms-dialog-confirmation',
  template: `
    <mat-dialog-content>{{ data.message }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancel()">
        {{ cancelButtonLabel }}
      </button>
      <button mat-button (click)="confirm()" cdkFocusInitial>
        {{ confirmButtonLabel }}
      </button>
    </mat-dialog-actions>
  `,
})
export class DialogConfirmationComponent {
  confirmButtonLabel: string;
  cancelButtonLabel: string;

  constructor(
    private dialogRef: MatDialogRef<DialogConfirmationComponent>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.confirmButtonLabel =
      this.data.confirmButtonLabel ||
      this.translateService.instant('actions.confirm');

    this.cancelButtonLabel = this.translateService.instant('actions.cancel');
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
